<div class="progress h-100"
     [style.width.%]="percent"
     [style.background-color]="color">
</div>
